import React, { useState } from "react";
import { X, Sparkles, ArrowRight } from "lucide-react";

const AnnouncementBar = () => {
    const [hidden, setHidden] = useState(
        () => sessionStorage.getItem("hl-announce-dismissed") === "1"
    );

    if (hidden) return null;

    const dismiss = () => {
        sessionStorage.setItem("hl-announce-dismissed", "1");
        setHidden(true);
    };

    return (
        <div
            data-testid="announcement-bar"
            className="relative bg-hl-brown text-[#E8D9B5] hl-grain"
        >
            <a
                href="https://aphroditeroots.com/?utm_source=icookgreek&utm_medium=ebook&utm_campaign=ebook_showcase&utm_content=top_banner"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="announcement-bar-link"
                className="group flex items-center justify-center gap-2.5 px-10 py-2 text-[10px] md:text-[11px] uppercase tracking-[0.22em] hover:text-[#f3e9cf] transition-colors"
            >
                <Sparkles className="w-3 h-3 shrink-0" strokeWidth={1.5} />
                <span className="truncate">
                    Aphrodite's Roots — wild oregano &amp; carob syrup from Cyprus.{" "}
                    <span className="underline underline-offset-4 decoration-[#E8D9B5]/50 group-hover:decoration-[#f3e9cf]">
                        Preorder the first batch
                    </span>
                </span>
                <ArrowRight className="w-3 h-3 shrink-0 transition-transform group-hover:translate-x-0.5" strokeWidth={1.5} />
            </a>
            <button
                onClick={dismiss}
                data-testid="announcement-bar-dismiss"
                aria-label="Dismiss announcement"
                className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-[#E8D9B5]/60 hover:text-[#E8D9B5] transition-colors"
            >
                <X className="w-3.5 h-3.5" strokeWidth={1.5} />
            </button>
        </div>
    );
};

export default AnnouncementBar;
